import React, { PureComponent } from 'react';
import { ReactSVG } from 'react-svg';
import _slice from 'lodash/slice';
import Image from 'next/image';

import { importStatic } from 'utils';

import Carousel from '../../components/carousel/index';

import styles from './Testimonial.module.css';

class Testimonial extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      scrollDistance: 500,
      dotsLoop: this.props.usersList,
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.setState({
      scrollDistance: this.ref.current && this.ref.current.clientWidth,
    });

    const { usersList } = this.props;
    const isMobileView = window && window.innerWidth <= 768;
    const updatedDotsLoop = _slice(
      usersList,
      0,
      isMobileView ? usersList.length : usersList.length - 1
    );
    this.setState({ dotsLoop: updatedDotsLoop });
  }

  render() {
    const { usersList } = this.props;
    const { scrollDistance, dotsLoop } = this.state;

    return (
      <section className="section">
        <div className={styles['site-testimonials-sec']}>
          <h2 className="brandonH2">What people say about Zippia’s career platform</h2>

          <Carousel
            inputProps={{
              dots: true,
              dotLoop: dotsLoop,
              className: {
                outer: `container ${styles['testimonials-outer-container']}`,
                inner: `${styles['site-testimonials-container']}`,
                middle: `${styles['site-testimonials-container-cutoff']}`,
              },
              id: 'testimonials-container',
              distance: scrollDistance,
              duration: 550,
              hideArrowsInMobile: true,
              arrowClass: {
                left: 'prevImg d-none d-lg-block',
                right: 'nextImg d-none d-lg-block',
              },
            }}
          >
            {usersList.map((user, index) => (
              <div
                className={styles['testimonial-container']}
                key={`userList_${index}`}
                ref={this.ref}
              >
                <div className={styles['testimonial-box']}>
                  <ReactSVG
                    src={importStatic('/ui-router/images/doubleQuote.svg')}
                    beforeInjection={(svg) => {
                      svg.querySelector('path').setAttribute('fill', user.color);
                    }}
                  />
                  <p className={styles['testimonial-quote']}>{user.testimonial}</p>
                  <div className={styles['testimonial-user']}>
                    <div className={styles['testimonial-user-image']}>
                      <Image
                        width="48"
                        height="48"
                        layout="fixed"
                        src={user.userImage}
                        className={`${styles['testimonial-user-image']} noSelect`}
                        alt={user.userName}
                      />
                    </div>
                    <div className={styles['testimonial-user-details']}>
                      <p className={styles['testimonial-user-name']}>{user.userName}</p>
                      <p className={styles['testimonial-user-background']}>{user.userBackground}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </section>
    );
  }
}

export default Testimonial;
